import Splide from "@splidejs/splide";

const getCarouselIds = (prefix) => {
    return Array.from(document.querySelectorAll(`[id^="${prefix}"]`))
        .map(element => element.id.match(new RegExp(`^${prefix}(\\d+)$`)))
        .filter(Boolean)
        .map(match => match[0]);
};

const initializeSplide = (carouselId, options) => {
    try {
        new Splide(`#${carouselId}`, options).mount();
    } catch (error) {
        console.error(`Error initializing Splide for ${carouselId}:`, error);
    }
};

const initializeFeaturedCardCarouselSplide = (carouselId) => {
    // Check if arrows and pagination are  availbile, befor rendering them
    const arrows = document.querySelector(`#${carouselId} .splide__arrows`);
    const pagination = document.querySelector(`#${carouselId} .splide__pagination`);

    initializeSplide(carouselId, {
        type: "slide",
        perPage: 1,
        focus: 0,
        gap: "24px",
        paginationKeyboard: true,
        padding: {
            left: "calc((100dvw - 1248px) / 2)",
            right: "calc((100dvw - 1248px) / 2)"
        },
        breakpoints: {
            1280: { padding: { left: "20px", right: "20px" } }
        },
        arrows: arrows ? true : false,
        pagination: pagination ? true : false,
        drag: "free",
        snap: true,
    });
};

const initializeImageCarouselSplide = (carouselId) => {
    // Check if arrows and pagination are  availbile, befor rendering them
    const arrows = document.querySelector(`#${carouselId} .splide__arrows`);
    const pagination = document.querySelector(`#${carouselId} .splide__pagination`);

    initializeSplide(carouselId, {
        type: "slide",
        perPage: 1,
        focus: 0,
        gap: "16px",
        paginationKeyboard: true,
        padding: { left: "0px", right: "0px" },
        arrows: arrows ? true : false,
        pagination: pagination ? true : false,
        drag: "free",
        snap: true,
    });
};

const prepareSliderEnhancement = () => {
    const featuredCardSlidersId = getCarouselIds("featuredContentCarouselContainer");
    featuredCardSlidersId.forEach(initializeFeaturedCardCarouselSplide);

    const imageCarouselSlidersId = getCarouselIds("imageCarousel");
    imageCarouselSlidersId.forEach(initializeImageCarouselSplide);
};

export default prepareSliderEnhancement;